import { faMarker, faWaveSquare } from '@fortawesome/free-solid-svg-icons'
import { fa42Group, faTypo3 } from '@fortawesome/free-brands-svg-icons'
import createField from '../../../utils/factory/createField'

export const filterFields = [
  {
    section: 'Filtros para o relatório',
    fields: [
      createField({
        id: 'filter.stock_status',
        label: 'Situação do Estoque',
        placeholder: 'Selecione a situação',
        type: 'select',
        icon: faWaveSquare,
        fullWidth: true,
        defaultValue: { value: 'below', label: 'Abaixo do Mínimo (inclui zerados)' },
      }),
      createField({
        id: 'filter.type_id',
        label: 'Tipo',
        placeholder: 'Selecione o tipo do produto',
        type: 'select',
        isMulti: true,
        icon: faTypo3,
      }),
      createField({
        id: 'filter.group_id',
        label: 'Grupo',
        placeholder: 'Selecione o grupo do produto',
        type: 'select',
        isMulti: true,
        icon: fa42Group,
      }),
      createField({
        id: 'filter.brand_id',
        label: 'Marca',
        placeholder: 'Selecione a marca do produto',
        type: 'select',
        fullWidth: true,
        isMulti: true,
        icon: faMarker,
      }),
    ],
  },
]